import { inject,Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../src/environments/env';
import { Injectable } from '@angular/core';
import { BehaviorSubject,Observable } from 'rxjs';
import Utils from '../../utils/utils';
import { MatDialog } from '@angular/material/dialog';
import { LogoutModalComponent } from '../../component/logout-modal/logout-modal.component';
@Injectable({
  providedIn: 'root'
})

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  standalone: false,
  styleUrl: './error.component.scss'
})
export class ErrorComponent {
  public logOutDialogConfig: any = {};
  public util = inject(Utils);
public dialogModel = inject(MatDialog);
  constructor(private router:Router){}

      
  ngOnInit(){

    let msg = "Your session is currently inactive.";

    this.logOutDialogConfig = {
                type: 'logout',
                forComponent: 'logout',
                value: msg,
                caseScenario: 1//this.util.checkForSubstring(msg)
              }
    
              this.dialogModel.open(LogoutModalComponent, { data: this.logOutDialogConfig, disableClose: true });
    
    //window.open(environment.BASE_URL + "/ptp/security/ssoLogout?entryPoint=" + environment.APP_URL + "/#/prelogin", '_self')
  }

}
